export default __webpack_public_path__ + "static/media/GC_sign_in_image.f4087df1.png";